/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoUploadAttachmentsToDraftInput = {
    clientMutationId?: string | null;
    ticketSlug: string;
    attachments: Array<DraftAttachmentArgument>;
    entitySlug?: string | null;
    entityType?: string | null;
    folderSlug: string;
    filesH?: any | null;
};
export type DraftAttachmentArgument = {
    identifier: string;
    name: string;
    signed?: boolean | null;
    documentType?: string | null;
};
export type DraftFileCreationDialogUploadMutationVariables = {
    input: infoUploadAttachmentsToDraftInput;
};
export type DraftFileCreationDialogUploadMutationResponse = {
    readonly infoUploadAttachmentsToDraft: {
        readonly clientMutationId: string | null;
    } | null;
};
export type DraftFileCreationDialogUploadMutation = {
    readonly response: DraftFileCreationDialogUploadMutationResponse;
    readonly variables: DraftFileCreationDialogUploadMutationVariables;
};



/*
mutation DraftFileCreationDialogUploadMutation(
  $input: infoUploadAttachmentsToDraftInput!
) {
  infoUploadAttachmentsToDraft(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoUploadAttachmentsToDraftPayload",
    "kind": "LinkedField",
    "name": "infoUploadAttachmentsToDraft",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DraftFileCreationDialogUploadMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DraftFileCreationDialogUploadMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "eeacb7c70ba2aed3c00450e13d72d9b6",
    "id": null,
    "metadata": {},
    "name": "DraftFileCreationDialogUploadMutation",
    "operationKind": "mutation",
    "text": "mutation DraftFileCreationDialogUploadMutation(\n  $input: infoUploadAttachmentsToDraftInput!\n) {\n  infoUploadAttachmentsToDraft(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'bcd869fa6fcc4068507e59b7093642ce';
export default node;
